import {useFeatureIsOn} from "@growthbook/growthbook-react";

import {useCookies} from "@khan/data-cookies";

import type {AppFeatures} from "./app-features.ts";

/**
 * Check the status of a feature flag via GrowthBook and local cookie.
 *
 * If the cookie is set, it overrides the GrowthBook value.
 *
 * @param flagName - The name of the feature as defined in GrowthBook.
 * @returns boolean - true if the feature is enabled, false otherwise.
 */
export function useFeatureIsOnWithOverride(
    flagName: keyof AppFeatures,
): boolean {
    const featureFlag = useFeatureIsOn<AppFeatures>(flagName);
    const cookieValue = useCookies()?.getFeatureOverride(flagName);
    return cookieValue ?? featureFlag;
}
